import { render, staticRenderFns } from "./select-task-tags.vue?vue&type=template&id=2ef93b81&"
import script from "./select-task-tags.vue?vue&type=script&lang=ts&"
export * from "./select-task-tags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports